import baywoodThumbnail from "@/public/images/youtubeThumbnails/testimonials/baywood-thumbnail.png";
import bishuThumbnail from "@/public/images/youtubeThumbnails/testimonials/bishu-thumbnail.jpeg";
import borodaThumbnail from "@/public/images/youtubeThumbnails/testimonials/boroda-thumbnail.jpg";
import dilbyThumbnail from "@/public/images/youtubeThumbnails/testimonials/dilby-thumbnail.jpeg";
import djPainThumbnail from "@/public/images/youtubeThumbnails/testimonials/dj-pain-thumbnail.png";
import doctorMixThumbnail from "@/public/images/youtubeThumbnails/testimonials/doctor-mix-thumbnail.jpg";
import doctorMix2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/doctor-mix2-thumbnail.jpg";
import fluxeonThumbnail from "@/public/images/youtubeThumbnails/testimonials/fluxeon-thumbnail.jpeg";
import jSewellThumbnail from "@/public/images/youtubeThumbnails/testimonials/j-sewell-thumbnail.jpeg";
import jeffyGThumbnail from "@/public/images/youtubeThumbnails/testimonials/jeffy-g-thumbnail.jpeg";
import kHartThumbnail from "@/public/images/youtubeThumbnails/testimonials/k-hart-thumbnail.jpeg";
import kodruThumbnail from "@/public/images/youtubeThumbnails/testimonials/kodru-thumbnail.jpeg";
import lanewoodStudios2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/lanewood-studios-2-thumbnail.jpeg";
import lanewoodStudios3Thumbnail from "@/public/images/youtubeThumbnails/testimonials/lanewood-studios-3-thumbnail.jpg";
import lanewoodStudiosThumbnail from "@/public/images/youtubeThumbnails/testimonials/lanewood-studios-thumbnail.png";
import learningMusicSkillsThumbnail2 from "@/public/images/youtubeThumbnails/testimonials/learning-music-skills-2-thumbnail.jpeg";
import learningMusicSkillsThumbnail from "@/public/images/youtubeThumbnails/testimonials/learning-music-skills-thumbnail.jpeg";
import lonerThumbnail from "@/public/images/youtubeThumbnails/testimonials/loner-thumbnail.jpeg";
import manifxtsoundsThumbnail from "@/public/images/youtubeThumbnails/testimonials/manifxtsounds-thumbnail.jpeg";
import mjdThumbnail from "@/public/images/youtubeThumbnails/testimonials/mjd-thumbnail.png";
import OdyccyThumbnail from "@/public/images/youtubeThumbnails/testimonials/odyccy-thumbnail.jpeg";
import omitoBeatsThumbnail from "@/public/images/youtubeThumbnails/testimonials/omito-beats-thumbnail.jpeg";
import ozgunThumbnail from "@/public/images/youtubeThumbnails/testimonials/ozgun-thumbnail.jpeg";
import ozgun2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/ozgun2-thumbnail.jpg";
import producerMykahThumbnail from "@/public/images/youtubeThumbnails/testimonials/producer-mykah-thumbnail.jpeg";
import producerMykah2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/producer-mykah2-thumbnail.jpg";
import producerMykah3Thumbnail from "@/public/images/youtubeThumbnails/testimonials/producer-mykah3-thumbnail.jpg";
import producerMykah4Thumbnail from "@/public/images/youtubeThumbnails/testimonials/producer-mykah4-thumbnail.jpg";
import r3versalThumbnail from "@/public/images/youtubeThumbnails/testimonials/r3versal-thumbnail.jpeg";
import raytownProductionsThumbnail from "@/public/images/youtubeThumbnails/testimonials/raytown-productions-thumbnail.png";
import raytownProductions2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/raytown-productions2-thumbnail.jpg";
import recordingBlogThumbnail from "@/public/images/youtubeThumbnails/testimonials/recording-blog-thumbnail.jpeg";
import roomieThumbnail from "@/public/images/youtubeThumbnails/testimonials/roomie-thumbnail.jpeg";
import ryosThumbnail from "@/public/images/youtubeThumbnails/testimonials/ryos-thumbnail.jpeg";
import servidaMusicThumbnail from "@/public/images/youtubeThumbnails/testimonials/servida-music-thumbnail.jpg";
import severmanThumbnail from "@/public/images/youtubeThumbnails/testimonials/severman-thumbnail.jpeg";
import severman2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/severman2-thumbnail.jpg";
import severman3Thumbnail from "@/public/images/youtubeThumbnails/testimonials/severman3-thumbnail.jpg";
import shonciThumbnail from "@/public/images/youtubeThumbnails/testimonials/shonci-thumbnail.jpg";
import slipperyHazeThumbnail from "@/public/images/youtubeThumbnails/testimonials/slippery-haze-thumbnail.jpeg";
import sonanceSoundsThumbnail from "@/public/images/youtubeThumbnails/testimonials/sonance-sounds-thumbnail.jpeg";
import sonicScoopThumbnail from "@/public/images/youtubeThumbnails/testimonials/sonic-scoop-thumbnail.jpeg";
import sonicScoop2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/sonic-scoop2-thumbnail.jpg";
import soundlearn2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/soundlearn-2-thumbnail.jpeg";
import soundlearnThumbnail from "@/public/images/youtubeThumbnails/testimonials/soundlearn-thumbnail.png";
import spinlightStudioThumbnail from "@/public/images/youtubeThumbnails/testimonials/spinlight-studio-thumbnail.jpeg";
import spinlightStudio2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/spinlight-studio2-thumbnail.jpg";
import steveMontiThumbnail from "@/public/images/youtubeThumbnails/testimonials/steve-monti-thumbnail.jpg";
import synthetThumbnail from "@/public/images/youtubeThumbnails/testimonials/synthet-thumbnail.jpeg";
import synthet2Thumbnail from "@/public/images/youtubeThumbnails/testimonials/synthet2-thumbnail.jpeg";
import synthet3Thumbnail from "@/public/images/youtubeThumbnails/testimonials/synthet3-thumbnail.jpg";
import synthet4Thumbnail from "@/public/images/youtubeThumbnails/testimonials/synthet4-thumbnail.jpg";
import theXGuyThumbnail from "@/public/images/youtubeThumbnails/testimonials/the-x-guy-thumbnail.jpeg";
import thomasFosterMusikproduktionThumbnail from "@/public/images/youtubeThumbnails/testimonials/thomas-foster-musikproduktion-thumbnail.jpeg";
import uranus20Thumbnail from "@/public/images/youtubeThumbnails/testimonials/uranus20-thumbnail.jpeg";
import wildcrowThumbnail from "@/public/images/youtubeThumbnails/testimonials/wildcrow-thumbnail.jpeg";
import { VideoReviewType } from "@/types/types";

export const videoReviews: VideoReviewType[] = [
  {
    youtubeVideoId: "tqD4lor9bE0",
    image: sonicScoop2Thumbnail,
    imageAlt: "Image of SonicScoop video 2",
  },
  {
    youtubeVideoId: "32Na0tjahFU",
    image: spinlightStudio2Thumbnail,
    imageAlt: "Image of Spinlight Studio video 2",
  },
  {
    youtubeVideoId: "fB7oZ2fe56Y",
    image: producerMykah2Thumbnail,
    imageAlt: "Image of Producer Mykah video 2",
  },

  {
    youtubeVideoId: "_BdjTnXZO9c",
    image: doctorMix2Thumbnail,
    imageAlt: "Image of Doctor Mix video 2",
  },

  {
    youtubeVideoId: "4LWJ_qdYcWQ",
    image: shonciThumbnail,
    imageAlt: "Image of Shonci video",
  },

  {
    youtubeVideoId: "U3Tfpl3kZdk",
    image: servidaMusicThumbnail,
    imageAlt: "Image of Servida Music video",
  },
  {
    youtubeVideoId: "dulq8IJR9nI",
    image: synthet4Thumbnail,
    imageAlt: "Image of Synthet video 4",
  },
  {
    youtubeVideoId: "-a97MtfExv0",
    image: severman3Thumbnail,
    imageAlt: "Image of Severman video 3",
  },
  {
    youtubeVideoId: "MXc18CMx4lU",
    image: producerMykah3Thumbnail,
    imageAlt: "Image of Producer Mykah video 3",
  },
  {
    youtubeVideoId: "8o7G1YkM3Ng",
    image: synthet3Thumbnail,
    imageAlt: "Image of Synthet video 3",
  },

  {
    youtubeVideoId: "BcDTaAsyBs0",
    image: ozgun2Thumbnail,
    imageAlt: "Image of Ozgun video 2",
  },
  {
    youtubeVideoId: "dkesCjUF3Zk",
    image: doctorMixThumbnail,
    imageAlt: "Image of Doctor Mix video",
  },
  {
    youtubeVideoId: "LOV83ZG9g-Q",
    image: producerMykah4Thumbnail,
    imageAlt: "Image of Producer Mykah video 4",
  },
  {
    youtubeVideoId: "xOAWCBtOb-c",
    image: raytownProductions2Thumbnail,
    imageAlt: "Image of Raytown Productions video 2",
  },

  {
    youtubeVideoId: "HwLzx22aBS0",
    image: steveMontiThumbnail,
    imageAlt: "Image of Steve Monti video",
  },
  {
    youtubeVideoId: "eSwWOWXD3Es",
    image: lanewoodStudios3Thumbnail,
    imageAlt: "Image of Lanewood Studios video 3",
  },

  {
    youtubeVideoId: "EOCnyPcONCk",
    image: roomieThumbnail,
    imageAlt: "Image of Roomie video",
  },
  {
    youtubeVideoId: "luJR7bk2rZQ",
    image: sonicScoopThumbnail,
    imageAlt: "Image of SonicScoop video",
  },
  {
    youtubeVideoId: "-eOcIR0igdQ",
    image: synthet2Thumbnail,
    imageAlt: "Image of Synthet video 2",
  },
  {
    youtubeVideoId: "XzJyRkpOwe4",
    image: ozgunThumbnail,
    imageAlt: "Image of Ozgun video",
  },
  {
    youtubeVideoId: "ZcNWzFYp2BI",
    image: thomasFosterMusikproduktionThumbnail,
    imageAlt: "Image of Thomas Foster Musikproduktion video",
  },
  {
    youtubeVideoId: "z9g3nJQef80",
    image: bishuThumbnail,
    imageAlt: "Image of Bishu video",
  },
  {
    youtubeVideoId: "Hv2fSVQzsJQ",
    image: synthetThumbnail,
    imageAlt: "Image of Synthet video",
  },
  {
    youtubeVideoId: "S1oaDUo45Qo",
    image: borodaThumbnail,
    imageAlt: "Image of Boroda video",
  },
  {
    youtubeVideoId: "pIxzXJnFRYk",
    image: severman2Thumbnail,
    imageAlt: "Image of Severman video 2",
  },
  {
    youtubeVideoId: "iT-guNEIwno",
    image: recordingBlogThumbnail,
    imageAlt: "Image of Recording Blog video",
  },
  {
    youtubeVideoId: "u7ps6M7g7Qw",
    image: dilbyThumbnail,
    imageAlt: "Image of Dilby video",
  },
  {
    youtubeVideoId: "DVYWT3NsIaE",
    image: ryosThumbnail,
    imageAlt: "Image of Ryos video",
  },
  {
    youtubeVideoId: "xGGIBqfamzo",
    image: severmanThumbnail,
    imageAlt: "Image of Severman video",
  },
  {
    youtubeVideoId: "uQ1xm22cvmc",
    image: lonerThumbnail,
    imageAlt: "Image of Loner video",
  },
  {
    youtubeVideoId: "LDiQJxyFkDM",
    image: wildcrowThumbnail,
    imageAlt: "Image of Wildcrow video",
  },
  {
    youtubeVideoId: "YRTccZr5ohs",
    image: learningMusicSkillsThumbnail,
    imageAlt: "Image of Learning Music Skills video",
  },
  {
    youtubeVideoId: "cVLp7h-gt-g",
    image: learningMusicSkillsThumbnail2,
    imageAlt: "Image of Learning Music Skills video 2",
  },
  {
    youtubeVideoId: "xWA7Su9ZA_4",
    image: kHartThumbnail,
    imageAlt: "Image of K Hart video",
  },
  {
    youtubeVideoId: "43gblNkJTaQ",
    image: kodruThumbnail,
    imageAlt: "Image of Kodru video",
  },
  {
    youtubeVideoId: "1XnTMvJJoQw",
    image: jeffyGThumbnail,
    imageAlt: "Image of Jeffy G video",
  },
  {
    youtubeVideoId: "qHpnR4uz3ks",
    image: producerMykahThumbnail,
    imageAlt: "Image of Producer Mykah video",
  },
  {
    youtubeVideoId: "SXjjUIfrORE",
    image: fluxeonThumbnail,
    imageAlt: "Image of Fluxeon video",
  },
  {
    youtubeVideoId: "nRePZ_UskZc",
    image: spinlightStudioThumbnail,
    imageAlt: "Image of Spinlight Studio video",
  },
  {
    youtubeVideoId: "Vggzb6Vf-S4",
    image: lanewoodStudiosThumbnail,
    imageAlt: "Image of Lanewood Studios video",
  },
  {
    youtubeVideoId: "VruS8HD-ssk",
    image: lanewoodStudios2Thumbnail,
    imageAlt: "Image of Lanewood Studios video 2",
  },
  {
    youtubeVideoId: "sywS0ZAxzso",
    image: slipperyHazeThumbnail,
    imageAlt: "Image of Slippery Haze video",
  },
  {
    youtubeVideoId: "91_C6r-Frkc",
    image: sonanceSoundsThumbnail,
    imageAlt: "Image of Sonance Sounds video",
  },
  {
    youtubeVideoId: "Z2PhrHJPkRo",
    image: djPainThumbnail,
    imageAlt: "Image of DJ Pain video",
  },
  {
    youtubeVideoId: "G1CjURnlb0M",
    image: raytownProductionsThumbnail,
    imageAlt: "Image of Raytown Productions video",
  },
  {
    youtubeVideoId: "fWK3ivOdM5A",
    image: jSewellThumbnail,
    imageAlt: "Image of JSewell video",
  },
  {
    youtubeVideoId: "yGM4ySC9JdA",
    image: OdyccyThumbnail,
    imageAlt: "Image of Odyccy video",
  },
  {
    youtubeVideoId: "S1B6v5CgyFY",
    image: soundlearnThumbnail,
    imageAlt: "Image of Soundlearn video",
  },
  {
    youtubeVideoId: "CsLBc2CwC0E",
    image: soundlearn2Thumbnail,
    imageAlt: "Image of Soundlearn video",
  },
  {
    youtubeVideoId: "CFJGS3CLVDI",
    image: baywoodThumbnail,
    imageAlt: "Image of Baywood video",
  },
  {
    youtubeVideoId: "Jh1JjkqrKCE",
    image: r3versalThumbnail,
    imageAlt: "Image of R3versal video",
  },
  {
    youtubeVideoId: "O00s3FTUl44",
    image: manifxtsoundsThumbnail,
    imageAlt: "Image of Manifxtsounds video",
  },
  {
    youtubeVideoId: "m4x4jstuDvo",
    image: mjdThumbnail,
    imageAlt: "Image of MJD video",
  },
  {
    youtubeVideoId: "QODhb4Insuo",
    image: omitoBeatsThumbnail,
    imageAlt: "Image of Omito Beats video",
  },
  {
    youtubeVideoId: "GbmN5pXj0YY",
    image: uranus20Thumbnail,
    imageAlt: "Image of Uranus20 video",
  },
  {
    youtubeVideoId: "j3arOOvlCn4",
    image: theXGuyThumbnail,
    imageAlt: "Image of The X Guy video",
  },
];
